import * as React from "react";
import { PopularCategories } from "../../Common";

import { useHideBanner } from "../hooks";

import { PresentationThemeProduct } from "../model";

import {
  useProductListPresentationModel,
  useReactPlpInitialState,
} from "../providers";

import { RecommendedForYou } from "../recommended-for-you";

export const PageNoResults: React.FunctionComponent = () => {
  const { presentationThemes } = useProductListPresentationModel();

  const {
    initialState: { baseQuery },
  } = useReactPlpInitialState();

  useHideBanner();

  const zeroResultsTheme = React.useMemo(() => {
    let zeroResultsTheme;
    for (const [key, value] of Object.entries(presentationThemes)) {
      if (key === "zero_results") {
        zeroResultsTheme = value;
      }
    }
    return zeroResultsTheme;
  }, [presentationThemes]);

  const zeroResultsThemeProducts = React.useMemo(() => {
    let zeroResultsThemeProducts: PresentationThemeProduct[] = [];
    if (zeroResultsTheme) {
      zeroResultsThemeProducts =
        zeroResultsTheme.items as PresentationThemeProduct[];
    }
    return zeroResultsThemeProducts;
  }, [zeroResultsTheme]);

  return (
    <React.Fragment>
      <div className="no-search-results-page-state-description-title">
        <h1>{`We couldn’t find any results for “${
          baseQuery?.search || ""
        }”`}</h1>
        <h3>{`Check the spelling or try again using different keywords.`}</h3>
      </div>

      <PopularCategories useInitialState={useReactPlpInitialState} />
      <RecommendedForYou products={zeroResultsThemeProducts} />
    </React.Fragment>
  );
};
